import {
  APIFieldAttributes,
  ApplyGlobalFieldToTypesPayload,
  ApplyGlobalFieldToTypesResponse,
  ArdoqId,
  GlobalFieldUsageResponse,
  Named,
  UnapplyGlobalFieldFromTypesPayload,
  UnapplyGlobalFieldFromTypesResponse,
} from '@ardoq/api-types';
import {
  fetchEntities,
  Method,
  fetchJson,
  headers,
  toRequestOptions,
} from './api';
import { ApiResponse } from './types';

const recalculate = (
  fieldId: ArdoqId,
  branchId?: ArdoqId | null
): ApiResponse<void> => {
  const request = new Request(
    `/api/field/${fieldId}/recalculate${
      branchId ? `?branchId=${branchId}` : ''
    }`,
    toRequestOptions(Method.POST, null)
  );
  return fetchJson<void>(request);
};

const recalculateAll = (): ApiResponse<void> => {
  const request = new Request(
    '/api/field/global/recalculate',
    toRequestOptions(Method.POST, null)
  );
  return fetchJson<void>(request);
};

const generateName = (label: string): ApiResponse<Named> => {
  const request = new Request(
    '/api/field/generate-name',
    toRequestOptions(Method.POST, { label })
  );
  return fetchJson<Named>(request);
};

const getGlobalFieldUsage = (
  fieldId: ArdoqId
): ApiResponse<GlobalFieldUsageResponse> => {
  const request = new Request(
    `/api/metamodel-sync/global-field/${fieldId}/usage`,
    { headers }
  );
  return fetchJson<GlobalFieldUsageResponse>(request);
};

const applyToTypes = (
  fieldId: ArdoqId,
  payload: ApplyGlobalFieldToTypesPayload
): ApiResponse<ApplyGlobalFieldToTypesResponse> => {
  const request = new Request(
    `/api/field/${fieldId}/global/apply-to-types`,
    toRequestOptions(Method.POST, payload)
  );
  return fetchJson<ApplyGlobalFieldToTypesResponse>(request);
};

const unapplyFromTypes = (
  fieldId: ArdoqId,
  payload: UnapplyGlobalFieldFromTypesPayload
): ApiResponse<UnapplyGlobalFieldFromTypesResponse> => {
  const request = new Request(
    `/api/field/${fieldId}/global/unapply-from-types`,
    toRequestOptions(Method.POST, payload)
  );
  return fetchJson<UnapplyGlobalFieldFromTypesResponse>(request);
};

export const fieldApi = {
  recalculate,
  recalculateAll,
  generateName,
  getGlobalFieldUsage,
  applyToTypes,
  unapplyFromTypes,
  fetchAll: fetchEntities<APIFieldAttributes>('field'),
};
